import { Injectable } from '@angular/core';

// Cache Service to handle the caching of the data
@Injectable()
export class CacheService {

    // Method to set a item to cache (session storage)
    public setItem(key: string, item: any) {
        if (typeof item != "string") {
            item = JSON.stringify(item);
        } else {
            item = JSON.stringify(new String(item));
        }
        sessionStorage.setItem(key, item);
    }

    // Method to get a item from cache (session storage)
    public getItem(key: string) {
        var item = sessionStorage.getItem(key);
        if (item && item != 'undefined') {
            return JSON.parse(item);
        } else {
            return undefined;
        }
    }

    // Method to remove a item from cache (session storage)
    public removeItem(key: string) {
        sessionStorage.removeItem(key);
        return 1;
    }

    // Method to clear the cache (session + local storage)
    public clear() {
        sessionStorage.clear();
        localStorage.clear();
        return 1;
    }

    // Method to set a item to cache (local storage)
    public setItemLocalStorage(key: string, item: any) {
        if (typeof item != "string") {
            item = JSON.stringify(item);
        } else {
            item = JSON.stringify(new String(item));
        }
        localStorage.setItem(key, item);
    }

    // Method to get a item from cache (local storage)
    public getLocalStorageItem(key: string) {
        var item = localStorage.getItem(key);
        if (item && item != 'undefined') {
            return JSON.parse(item);
        } else {
            return undefined;
        }
    }

    // Method to remove a item from cache (local storage)
    public removeItemLocalStorage(key: string) {
        localStorage.removeItem(key);
        return 1;
    }
}